module.exports = {
  select_community: 'Select community',
  availableCommunities: 'Available Communities',
  createCommunityPostModalTitle: 'Create community post',
  createCommunityPost: 'Create a post for the community',
  communityMembers: 'Community Members',
  managers: 'Managers',
  members: 'Members',
  searchMembers: 'Search',
  noMembersFound: 'No members found',
  description: 'Description',
  seeAll: 'See All',
  yourPost: 'Your post',
  communityPost: 'Community post',
  postActions: 'Post actions',
  showOnThread: 'Show on thread',
  postDoesNotExist: 'This post does not exist',
  deletePost: {
    title: 'Delete post?',
    confirmation: 'This post and all answers will be permanently deleted. You cannot undo this operation.',
    typeDelete: 'Type DELETE to confirm.',
    success: 'Post deleted.',
    error: 'Could not delete post. Please try again later.',
  },
  posts: {
    showLatestPosts: 'Show {count} new post | Show {count} new posts',
    noPosts: 'No posts yet',
    beFirstToPost: 'So, what\'s that one thing you\'ve always wanted to know?',
  },
  adminFeedbackPromptLine1: 'Haven\'t gotten the answer you need yet?',
  requestAdminFeedback: 'Request admin reply',
  adminFeedbackRequestedOn: 'You requested an admin reply on {date}.',
  adminFeedbackRequestSuccess: 'Admin reply requested successfully. An admin will reply to your post as soon as possible.',
  adminFeedbackRequestError: 'Error requesting admin reply. Please try again later.',
  adminReplyAlreadyRequested: 'Admin reply has already been requested for this post.',
}
